import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import {
  FDBodyText,
  FDClickableText, FDHeadlineText, FDLozenge, FDPaper, FDStack,
} from '@facet-wealth/design';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { PM2JourneyRoadmapAdjustmentDiffItem } from './item';

export const sectionMetaOverrideSet = buildBaseOverrides()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly);

const lozengeColorMap = {
  removed: 'error',
  minorChange: 'info',
  majorChange: 'warning',
  added: 'success',
  noChange: 'subtle',
};

export const PM2JourneyRoadmapAdjustmentDiffSection = () => {
  const { resource } = useMetaLayoutContext();

  const [showAll, setShowAll] = useState(false);

  const onClick = () => {
    setShowAll(!showAll);
  };

  const actionsThisMonth = resource.attr('firstMonthItems')?.resources().list();
  const futureActions = resource.attr('futureItems')?.resources().list();
  const hasRichTextContent = !!resource.attr('richTextContent');

  return (
    <FDPaper>
      <FDStack direction={'column'} padding={4} spacing={2} minWidth={725} maxWidth={725}>
        <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <MetaControlField attr={'title'} />
          <FDLozenge size={'lg'} label={resource.attr('status')} color={lozengeColorMap[resource.attr('type')]} />
        </FDStack>
        {hasRichTextContent ? (
          <MetaControlField attr={'richTextContent'} />
        ) : (
          <FDStack direction={'column'} spacing={2}>
            <MetaCollectionRenderer
              collection={resource.attr('firstMonthItems')}
              layout={PM2JourneyRoadmapAdjustmentDiffItem}
            />
            {actionsThisMonth.length === 0 ? <FDBodyText size={'md'} value={resource.attr('noFirstMonthActionsText')} /> : null }
            {showAll && <MetaCollectionRenderer
              collection={resource.attr('futureItems')}
              layout={PM2JourneyRoadmapAdjustmentDiffItem}
            />}
            {/* Only show the toggle text when there is more than one item */}
            {futureActions.length === 0 ? null : (
              <FDClickableText
                appearance={'standalone'}
                onClick={onClick}
                label={showAll ? 'Hide future changes' : `See ${futureActions.length} future changes`}
              />
            )}
          </FDStack>
        )}
      </FDStack>
    </FDPaper>
  );
};
